import React, { memo } from "react";

import type {
  QuantityButtonsConfig,
  WidgetRenderType,
} from "@intelligems/ig-types";

import { QuantityButtonsContextProvider } from "../QuantityButtonsView/context/QuantityButtonsContexProvider";
import { QuantityButtonsFactory } from "../QuantityButtonsView/QuantityButtonsFactory";
import { CalculateButtonState } from "../QuantityButtonsView/types";

import { resolveQuantityButtonsConfig } from "./resolveQuantityButtonsConfig";

export interface QuantityButtonsViewProps {
  renderType: WidgetRenderType;
  config: QuantityButtonsConfig;
  quantity: number;
  calculateButtonState: CalculateButtonState;
  formatter: (input: number) => string;
  onQuantityChange?: (quantity: number) => void;
}

export const QuantityButtonsView = memo((props: QuantityButtonsViewProps) => {
  const { desktop, mobile } = React.useMemo(
    () => resolveQuantityButtonsConfig(props.config.widget),
    [props.config]
  );
  switch (props.renderType) {
    case "all":
    case "desktop":
      return (
        <QuantityButtonsContextProvider {...props} widget={desktop}>
          <QuantityButtonsFactory />
        </QuantityButtonsContextProvider>
      );
    case "mobile":
      return (
        <QuantityButtonsContextProvider {...props} widget={mobile}>
          <QuantityButtonsFactory />
        </QuantityButtonsContextProvider>
      );
  }
});
